import type { RouteDefinition } from '@trello/router/routes';

import { getRouteIdFromPathname } from './getRouteIdFromPathname';

export const isCurrentRoute = (route: RouteDefinition) => {
  return getRouteIdFromPathname(window.location.pathname) === route.id;
};
